import * as React from 'react';
import { Wrapper, WeekDay } from './styled';
import { WEEKDAYS } from '@app/src/common/datePicker/state/calendar/constants';

export const WeekDays: React.FC = () => (
  <Wrapper>
    { WEEKDAYS.map((weekday, index) => (
      <WeekDay key={index}>{weekday}</WeekDay>
    )) }
  </Wrapper>
);
